const systemAndInformationSchema = {
  Usuário: {
    properties: [
      {
        name: 'Email',
        value: 'userInformation?.email',
      },
      {
        name: 'Nome de usuário',
        value: 'userInformation?.displayName ?? "Não encontrado"',
      },
      {
        name: 'Número de telefone',
        value: 'userInformation?.phoneNumber ?? "Não encontrado"',
      },
    ],
  },
  Dispositivo: {
    properties: [
      {
        name: 'Nome',
        value: 'deviceInfo?.name',
      },
      {
        name: 'Identificador',
        value: 'deviceInfo?.identifier',
      },
      {
        name: 'Identificador real',
        value: 'realIdentifierResult?.value',
      },
      {
        name: 'Sistema operacional',
        value: 'deviceInfo?.os',
      },
      {
        name: 'Versão do sistema operacional',
        value: 'deviceInfo?.osVersion',
      },
      {
        name: 'Navegador',
        value: 'deviceInfo?.browserName',
      },
      {
        name: 'Versão do navegador',
        value: 'deviceInfo?.browserVersion',
      },
      {
        name: 'Quantidade de núcleos do processador',
        value:
          'navigator.hardwareConcurrency === undefined ? "Não suportado" : navigator.hardwareConcurrency',
      },
    ],
  },
  Resolução: {
    properties: [
      {
        name: 'Resolução da tela (width)',
        value: 'window.screen.width',
      },
      {
        name: 'Resolução da tela (height)',
        value: 'window.screen.height',
      },
      {
        name: 'Viewport (width)',
        value: 'window.innerWidth',
      },
      {
        name: 'Viewport (height)',
        value: 'window.innerHeight',
      },
    ],
  },
}

export default systemAndInformationSchema
